import { createTheme } from '@material-ui/core/styles';
import colors from 'Exports/colors.scss';

export default createTheme({
  type: 'light',
  palette: {
    primary: {
      light: colors['primary-400'],
      main: colors['primary'],
      dark: colors['primary-600'],
      contrastText: colors['white'],
    },
    secondary: {
      light: colors['secondary-400'],
      main: colors['secondary'],
      dark: colors['secondary-600'],
      contrastText: colors['white'],
    },
    grey: {
      100: colors['grey-100'],
      200: colors['grey-200'],
      300: colors['grey-300'],
      400: colors['grey-400'],
      500: colors['grey-500'],
      600: colors['grey-600'],
      700: colors['grey-700'],
      800: colors['grey-800'],
      900: colors['grey-900'],
    },
    error: {
      light: colors['error-400'],
      main: colors['error'],
      dark: colors['error-600'],
    },
    warning: {
      light: colors['warning-400'],
      main: colors['warning'],
      dark: colors['warning-600'],
    },
    success: {
      light: colors['success-400'],
      main: colors['success'],
      dark: colors['success-600'],
    },
  },
  props: {
    MuiTooltip: {
      arrow: true,
    },
    MuiFormControl: {
      margin: 'dense',
    },
    MuiTooltip: {
      placement: 'top',
      arrow: true,
    },
    MuiSelect: {
      variant: 'outlined',
    },
  },
  overrides: {
    MuiButton: {
      text: {
        padding: '8px 20px',
        color: colors['white'],
        backgroundColor: colors['primary'],
      },
    },
    MuiSelect: {},
    MuiChip: {
      root: {
        borderRadius: '4px',
      },
      sizeSmall: {
        padding: '2px 0',
      },
    },
    MuiTooltip: {
      tooltipPlacementTop: {
        margin: '8px 0',
      },
    },
    MuiFormControl: {
      root: {
        marginTop: 0,
        marginBottom: 0,
      },
      marginDense: {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    MuiOutlinedInput: {
      inputMarginDense: {
        padding: '12px',
      },
    },
  },
});
